export default __webpack_public_path__ + "static/media/case-study1.039af572.webp";